import { CartItem } from 'models/CartItem';
import styles from 'views/CheckoutPage/components/styles.scss';
import tagStyles from './styles.scss';
import Price from 'components/Shared/Price';
import cn from 'classnames';
import { Tag } from 'components/Tag';
import { useSelector } from 'react-redux';
import { selectIsValidated } from 'store/appShell/selector';

interface PriceContainerProps {
  item: CartItem;
  isLoading: boolean;
}

const getOriginalPrice = (isValidated: boolean, item: CartItem) =>
  isValidated ? item.originalLinePrice : item.priceBeforeSavings;

export const PriceContainerBob = ({ item, isLoading }: PriceContainerProps) => {
  const isValidated = useSelector(selectIsValidated);

  const showOriginalPrice = isValidated
    ? item.presentationPrice < item.originalLinePrice
    : item.presentationPrice !== item.priceBeforeSavings;

  return (
    <div
      className={cn(styles.priceContainer, {
        [styles.multiplePriceLines]: showOriginalPrice,
        [styles.loading]: isLoading
      })}
    >
      {!!item.originalPrice.discount && (
        <Tag text={`-${item.originalPrice.discount}%`} className={tagStyles.tag} />
      )}
      {showOriginalPrice && (
        <Price price={getOriginalPrice(isValidated, item)} appearance="lineThrough" />
      )}
      <strong>
        <Price price={item.presentationPrice} appearance="discount" />
      </strong>
    </div>
  );
};
